<ng-template #loadingPage>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
 </ng-template>

 <ng-template #spinner>
    <mat-spinner diameter="30"></mat-spinner>
 </ng-template>

 <ng-container *ngIf="!loading; else loadingPage">

 
    <div class="schedule" [formGroup]="scheduleReport.scheduleForm">
        <div class="notice-row">
            <div color="primary" class="notice">
                Excessively large reports may result in partial data or delayed delivery. For best results, consider breaking requests into smaller segments. We recommend 90 days or less. Thank you for your understanding.
            </div>
        </div>
        <div class="two-row">
            <div>
                <h3 color="primary">Schedule Name</h3>
                <mat-form-field class="common-minw50ex" *ngIf="scheduleReport?.scheduleForm?.get( 'schedule_name' ) as name">
                    <mat-label>Schedule Name</mat-label>
                    <input matInput [formControl]="name" [required]="true" pattern="" maxlength="50" />
                    <mat-error libInputErrors [control]="name"></mat-error>
                    <button matSuffix mat-icon-button (click)="name.reset()" *ngIf="name.value">
                        <mat-icon>clear</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="toggle">
                <mat-slide-toggle [color]="toggleColor" formControlName="active">Active</mat-slide-toggle>
            </div>
        </div>

        <h3 color="primary">Description</h3>
        <mat-form-field class="common-minw50ex" *ngIf="scheduleReport?.scheduleForm?.get( 'schedule_description' ) as description">
            <mat-label>Description</mat-label>
            <input matInput [formControl]="description" pattern="" maxlength="50" />
            <mat-error libInputErrors [control]="description"></mat-error>
            <button matSuffix mat-icon-button (click)="description.reset()" *ngIf="description.value">
                <mat-icon>clear</mat-icon>
            </button>
        </mat-form-field>

        <div class="task-recurrence">
            <h3 color="primary">Task Recurrence</h3>
            <mat-button-toggle-group formControlName="recurrence_period" [value]="scheduleReport.types"
                (change)="setRecType( $event.value )">
                <mat-button-toggle *ngFor="let t of reccurenceType$ | async" class="recurrence_period" [value]="t" [disabled]="false">{{t |
                    uppercase}}
                </mat-button-toggle>
            </mat-button-toggle-group>

        </div>

        <div *ngIf="scheduleReport.types">

            <lib-recurrence></lib-recurrence>

            <!-- <lib-schedule-time-zone></lib-schedule-time-zone> -->

            <lib-recipients></lib-recipients>

        </div>
        <div class="buttons">
            <ng-container *ngIf="!saving else spinner">
                <button class="save_btn" mat-flat-button color="primary"
                    [disabled]="!(scheduleReport.types) || scheduleReport.scheduleForm.invalid"
                    (click)="save()">
                    <mat-icon>save</mat-icon> SAVE
                </button>
                <button mat-stroked-button (click)="cancel()">
                    <mat-icon>clear</mat-icon> CANCEL
                </button>
            </ng-container>
        </div>

    </div>
    <!-- [disabled]="!(scheduleReport.types) || scheduleReport.scheduleForm.invalid" -->

</ng-container>